import React from 'react';
import { ActivityIndicator, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useSelector } from 'react-redux';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import { RootState } from '../../store/reducers';
import { USE_LITE_DRAFT_SAVE } from '../../constants/featureFlags';
import draftSaveService from '../../store/reducers/reportcache/draftSaveService';
import QuestionnaireDrawerButton from './QuestionnaireDrawerButton';
import { Report } from '../../utils/classes';

const DraftSaveButton = () => {
  const autoSaveStatus = useSelector((state: RootState) => state.draftSaveStatus.autoSaveStatus);
  const manualSyncStatus = useSelector((state: RootState) => state.draftSaveStatus.manualSyncStatus);
  const siteKey = useSelector((state: RootState) => state.site.selectedSiteKey);
  const reportKey = useSelector((state: RootState) => state.report.selectedReportKey);
  const selectedReport = useSelector((state: RootState) => state.report.selectedReport);

  const isSaving = autoSaveStatus === 'saving' || manualSyncStatus === 'saving';

  const handlePress = () => {
    if (!siteKey || !reportKey || !selectedReport) return;

    // TODO: Week-05 — trigger attachment upload before save
    draftSaveService.saveNow({
      siteKey,
      reportKey,
      report: selectedReport as Report
    });
  };

  return (
    <TouchableOpacity
      testID="audit-save-as-draft-btn"
      onPress={handlePress}
      disabled={isSaving}
      style={styles.saveButton}
    >
      {isSaving ? (
        <ActivityIndicator size="small" color="#fff" />
      ) : (
        <Icon name="content-save" size={28} color="#fff" />
      )}
    </TouchableOpacity>
  );
};

const QuestionnaireHeaderRight = () => {
  return (
    <View style={styles.container}>
      {USE_LITE_DRAFT_SAVE && <DraftSaveButton />}
      <QuestionnaireDrawerButton />
    </View>
  );
};

export default QuestionnaireHeaderRight;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  saveButton: {
    paddingHorizontal: 8,
    paddingVertical: 4
  }
});
